// super-excalidraw: thin client for the /api/v2 dashboard endpoints
// added by the Go backend patch. Exposes list / get-meta / rename / delete.

export type DashboardItem = {
  id: string;
  name: string;
  key?: string;
  createdAt: number;
  size: number;
  hasThumbnail: boolean;
  // Folder membership (empty/undefined = unfiled/root). Set via
  // moveDiagramToFolder in data/folders.ts.
  folderId?: string;
};

const base = "/api/v2";

export async function listDiagrams(): Promise<DashboardItem[]> {
  const r = await fetch(`${base}/list`);
  if (!r.ok) {
    throw new Error(`list failed: ${r.status}`);
  }
  return r.json();
}

export async function getMeta(id: string): Promise<DashboardItem> {
  const r = await fetch(`${base}/${id}/meta`);
  if (!r.ok) {
    throw new Error(`meta failed: ${r.status}`);
  }
  return r.json();
}

export async function renameDiagram(id: string, name: string): Promise<void> {
  const r = await fetch(`${base}/${id}/meta`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name }),
  });
  if (!r.ok) {
    throw new Error(`rename failed: ${r.status}`);
  }
}

export async function deleteDiagram(id: string): Promise<void> {
  const r = await fetch(`${base}/${id}`, { method: "DELETE" });
  if (!r.ok) {
    throw new Error(`delete failed: ${r.status}`);
  }
}

// Build the URL Excalidraw recognises when loading from the hash.
// id + key recreates the same /#json=ID,KEY format used by the share flow,
// so opening a dashboard item is identical to clicking a shareable link.
export function diagramUrl(item: DashboardItem): string {
  const url = new URL(window.location.href);
  url.hash = `json=${item.id},${item.key ?? ""}`;
  url.search = "";
  return url.toString();
}

export function thumbnailUrl(id: string): string {
  return `${base}/${id}/thumbnail`;
}
